import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ErrorHandler, enableProdMode, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { Routes, provideRouter } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { environment } from '@environments/environment';
import { HttpInterceptor } from '@interceptors/http-interceptor.service';
import { TraceService, createErrorHandler, init } from '@sentry/angular';
import { SentryConfig } from '@src/sentry.config';

if (environment.production) {
  enableProdMode();
  init(SentryConfig);
}

const routes: Routes = [
  {
    path: ':id',
    component: AppComponent,
  },
];

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([HttpInterceptor])),
    {
      provide: ErrorHandler, useValue: createErrorHandler({ showDialog: false }),
    },
    provideAppInitializer(() => {
      inject(TraceService);
    }),
  ],
});
